import { MultiSelect, Icons, Button } from '@commenda/kakashi';
import { MultiSelectFilterConfig } from '../types';
interface MultiSelectFilterProps {
    config: MultiSelectFilterConfig;
    values: string[];
    onChange: (values: string[]) => void;
    disabled?: boolean;
}

export const MultiSelectFilter = ({ config, values, onChange, disabled = false }: MultiSelectFilterProps) => {
    return (
        <MultiSelect
            options={config.options}
            hideSelectAll
            defaultValue={values}
            onValueChange={onChange}
            disabled={disabled}
            placeholder={config.placeholder || config.label}
            hideSearch={(config.options || []).length < 10}
            renderOption={({ option, isSelected }) => (
                <div className="flex items-center justify-between w-full">
                    <span className="txt-medium-regular text-sm text-button-secondary-fg truncate">
                        {option.label}
                    </span>
                    <div className="w-4 shrink-0 ml-2">
                        {isSelected && <Icons.Check className="size-4" />}
                    </div>
                </div>
            )}
            renderTrigger={({ placeholder }) => (
                <Button
                    variant="secondary"
                    className="flex h-10 w-full border border-border-primary items-center justify-between rounded-md bg-bg-primary px-3.5 py-2.5 txt-medium-regular disabled:cursor-not-allowed disabled:bg-bg-disabled-subtle"
                    disabled={disabled}
                >
                    <span className="txt-small-medium text-button-secondary-fg truncate">
                        {config.label}
                    </span>
                    <Icons.ChevronDown className="size-4 shrink-0 text-fg-quaternary ml-2" />
                </Button>
            )}
        />
    );
};